import { defineNuxtPlugin } from 'nuxt/app'
import plugin from 'vue-yandex-maps'

export default defineNuxtPlugin(nuxtApp => {
  const config = useRuntimeConfig()

  const settings = {
    apiKey: config.public.YANDEX_MAPS_API_KEY,
    lang: 'ru_RU',
    coordorder: 'latlong',
    debug: false,
    version: '2.1',
  }

  nuxtApp.vueApp.use(plugin, settings)
})
